module.exports = __webpack_public_path__ + "assets/f0ddc8b817b44085a6ecbd5f06f65a45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu.png
// module id = 375
// module chunks = 1